import React from "react"
import { Flex, Text, DynamicLink, Icon, colors } from "@capioweb/ui-components"
import { BlockCommonLayout } from "../../utils/layout"
import styled from "styled-components"

export interface UnitItem {
	name: string
	url: string
}

export interface UnitListProps {
	a: UnitItem[]
	b: UnitItem[]
	c: UnitItem[]
	d: UnitItem[]
	e: UnitItem[]
	f: UnitItem[]
	g: UnitItem[]
	h: UnitItem[]
	i: UnitItem[]
	j: UnitItem[]
	k: UnitItem[]
	l: UnitItem[]
	m: UnitItem[]
	n: UnitItem[]
	o: UnitItem[]
	p: UnitItem[]
	q: UnitItem[]
	r: UnitItem[]
	s: UnitItem[]
	t: UnitItem[]
	u: UnitItem[]
	v: UnitItem[]
	w: UnitItem[]
	x: UnitItem[]
	y: UnitItem[]
	z: UnitItem[]
	å: UnitItem[]
	ä: UnitItem[]
	ö: UnitItem[]
}

export interface CapioNexusUnitListBlockProps {
	units: UnitListProps
}

const UlStyled = styled.ul`
	width: 100%;
	&:first-of-type {
		border-top: 1px solid ${colors.blue33};
	}

	:hover {
		svg path {
			fill: ${colors.hoverBlue};
		}
	}
`

const CapioNexusUnitListBlock: React.FC<CapioNexusUnitListBlockProps> = (
	props
) => {
	const letterList = props.units ? Object.getOwnPropertyNames(props.units) : []

	return letterList.length > 0 ? (
		<BlockCommonLayout>
			<Flex flexDirection="column" w={1} maxw={69} m="0 auto">
				{letterList.map((letter, i) => {
					const units: UnitItem[] = props.units[letter]
					//We check for $type since V8 Javascript engine adds this in SSR and cannot be removed in the backend
					return letter != "$type" && units && units.length > 0 ? (
						<Flex w={1} key={i} flexDirection="column">
							<Text mb={3} mt={3} variant="headline-2">
								{letter.toUpperCase()}
							</Text>
							<Flex w={1}>
								<UlStyled>
									{units.map((unit, x) => (
										<Flex as="li" key={`unitListItem${x}`} borderBottom w={1}>
											<DynamicLink url={unit?.url ?? "#"}>
												<Flex
													justifyContent="space-between"
													w={1}
													py={{ _: 2, m: 2.5 }}
													px={2}
												>
													<Text variant="headline-3" mb={0}>
														{unit.name}
													</Text>
													<Flex>
														<Icon icon="arrow-right" />
													</Flex>
												</Flex>
											</DynamicLink>
										</Flex>
									))}
								</UlStyled>
							</Flex>
						</Flex>
					) : null
				})}
			</Flex>
		</BlockCommonLayout>
	) : (
		<></>
	)
}

export { CapioNexusUnitListBlock }
